<template>
    <div class="overviewData">
        <div class="overviewData-card">
            <div class="overviewData-card-title">
                <div class="overviewData-card-title-slide"></div>
                <div class="overviewData-card-title-text">今日实时</div>
            </div>
            <div class="overviewData-card-content">
                <div v-for="(renderItem, renderIndex) in overviewPlanDataRenderList" :key="renderIndex" :class="`overviewData-card-content-item ${renderIndex >= (overviewPlanDataRenderList.length - renderRemainder) ? 'overviewData-card-content-item-end' : ''}`">
                    <div class="overviewData-card-content-item-name">{{renderItem.name}}</div>
                    <div class="overviewData-card-content-item-value">{{ orderTotalData[renderItem.key] | filterTotal }}</div>
                    <!-- <div class="overviewData-card-content-item-time">更新时间：{{orderTotalData[renderItem.updateDateKey]}}</div> -->
                </div>
            </div>
            <div class="overviewData-card-space"></div>
        </div>

        <div class="overviewData-card overviewData-echartsBox">
            <div class="overviewData-card-title">
                <div class="overviewData-card-title-slide"></div>
                <div class="overviewData-card-title-text">数据趋势</div>
            </div>
            <div class="overviewData-card-search">
                <Search :renderList="renderSearchList" :searchData="searchData" hideSearch @change="handleChangeSearchData"></Search>
            </div>
            <div class="overviewData-card-search-mobile">
                <RangePicker :maxInterval="14" :minStartDate="minStartDate" :maxEndDate="maxEndDate" v-model="searchData.dates" @confirm="handleConfirmDates"></RangePicker>
                <div class="overviewData-card-search-mobile-row">
                    <Picker label="指标" :options="overviewDataOptions" v-model="searchData.chartsType" @change="handleChangeChartsType"></Picker>
                </div>
            </div>
            <div class="overviewData-echarts">
                <div :style="`width: ${orderDayData.length * 1.5}rem;`" class="overviewData-echarts-content" ref="overviewData-echarts" v-if="orderDayData.length && !isLoading"></div>
                <div class="table-normal" v-if="!orderDayData.length && !isLoading">
                    <img src="@/assets/home/dataEffect/accountData/default_img_no_data.png" alt="">
                    <span>目前暂无数据</span>
                </div>
                <div v-if="isLoading">
                    <Loading></Loading>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { overviewDataRenderList, overviewPlanDataRenderList, renderSearchList, chartsTypeOptions } from './config'
import Search from '@/components/search/search.vue'
import moment from 'moment'
import * as echarts from 'echarts'
import { isEmpty } from '@/utils/common.js'
import { Message } from 'iview'
import Loading from '@/components/loading/loading.vue'
import RangePicker from '@/components/rangePicker/rangePicker.vue'
import Picker from '@/components/picker/picker.vue'

export default {
    components: {
        Search,
        Loading,
        RangePicker,
        Picker
    },
    data() {
        return {
            overviewDataRenderList: overviewDataRenderList,
            overviewPlanDataRenderList: overviewPlanDataRenderList,
            renderSearchList: renderSearchList,
            renderRemainder: overviewDataRenderList.length % 3 || 3,
            overviewDataOptions: chartsTypeOptions.map((item) => {
                return {
                    text: item.name,
                    value: item.key
                }
            }),
            searchData: {
                dates: [moment(new Date()).subtract(7, 'day').format('YYYY-MM-DD'), moment(new Date()).subtract(1, 'day').format('YYYY-MM-DD')],
                chartsType: 'customerOrderValidTotalSalePrice'
            },
            overviewDataMap: {},
            isLoading: true,
            orderDayData: [],
            orderTotalData: {},
            maxEndDate: new Date(moment(new Date()).subtract(1, 'day').format('YYYY-MM-DD')),
            minStartDate: new Date(moment(new Date()).subtract(2, 'year').format('YYYY-MM-DD'))
        }
    },
    filters: {
        filterTotal(value) {
            if (isEmpty(value)) {
                return '--'
            } else {
                if (value >= 10000) {
                    return `${Math.round((Number(value) / 100)) / 100}W`
                } else {
                    return `${value || 0}`
                }
            }
        }
    },
    mounted() {
        const overviewDataMap = {}
        for (let i = 0; i < chartsTypeOptions.length; i++) {
            const overviewDataRenderItem = chartsTypeOptions[i]
            overviewDataMap[overviewDataRenderItem.key] = overviewDataRenderItem.name
        }
        this.overviewDataMap = overviewDataMap
        this.getOrderTotalData()
        this.getOrderDayData()
    },

    methods: {

        // 获取消耗时间
        getCostTime() {
            const costTime = localStorage.getItem('costTime') || ''
            const date = new Date(), minute = date.getMinutes(), seconds = Math.floor(Math.random() * 60), secondsText = (seconds < 10 ? '0' : '') + seconds
            let newCostTime = ""
            if (minute < 2) {
                newCostTime = moment(date).subtract(1, 'hour').format('HH:') + '02:' + secondsText
            } else {
                newCostTime = moment(date).format('HH:') + '02:' + secondsText
            }
            if (costTime) {
                if (costTime.substring(0, 2) != moment(date).format('HH')) {
                    localStorage.setItem('costTime', newCostTime)
                    return newCostTime
                } else {
                    return costTime
                }
            } else {
                localStorage.setItem('costTime', newCostTime)
                return newCostTime
            }
        },

        // 获取默认时间
        getDefaultTime() {
            const date = new Date(), minute = date.getMinutes(), remainder = minute % 5, seconds = Math.floor(Math.random() * 60), secondsText = (seconds < 10 ? '0' : '') + seconds, defaultTime = localStorage.getItem('defaultTime') || ''
            let newDefaultTime = moment(date).subtract(remainder, 'minute').format('HH:mm:') + secondsText
            if (defaultTime) {
                if (defaultTime.substring(3, 5) != moment(date).subtract(remainder, 'minute').format('mm')) {
                    localStorage.setItem('defaultTime', newDefaultTime)
                    return newDefaultTime
                } else {
                    return defaultTime
                }
            } else {
                localStorage.setItem('defaultTime', newDefaultTime)
                return newDefaultTime
            }
        },

        // 获取订单数据
        getOrderTotalData() {
            this.$axios({
                url: '/api/syn/rebateDataPlat/advertise/total',
                data: {
                    startCreateDate: moment(new Date()).format('YYYY-MM-DD'),
                    endCreateDate: moment(new Date()).format('YYYY-MM-DD')
                },
                method: 'GET'
            }).then((res) => {
                if (isEmpty(res.Data)) {
                    this.orderTotalData = {}
                } else {
                    const orderValidTotalSalePrice = Number(res.Data.orderValidTotalSalePrice), cost = Number(res.Data.cost)
                    res.Data.inputOutputRatio = cost ? Math.round(orderValidTotalSalePrice * 100 / cost) / 100 : 0
                    res.Data.costTime = this.getCostTime()
                    res.Data.defaultTime = this.getDefaultTime()
                    this.orderTotalData = res.Data
                }

            })
        },

        //处理改变指标时触发
        handleChangeChartsType() {
            this.createECharts(this.orderDayData)
        },

        //处理时间区间筛选事件
        handleConfirmDates(event) {
            this.getOrderDayData()
        },

        // 按天获取订单数据
        getOrderDayData() {
            this.isLoading = true
            const searchData = { ...this.searchData }
            this.$axios({
                url: '/api/syn/rebateDataPlat/customer/orderTotal',
                data: {
                    startCreateDate: searchData.dates[0],
                    endCreateDate: searchData.dates[1]
                },
                method: 'GET'
            }).then((res) => {
                if (Array.isArray(res.Data.data) && res.Data.data.length) {
                    this.isLoading = false
                    this.orderDayData = res.Data.data.map((orderItem) => {
                        const customerOrderValidTotalSalePrice = Number(orderItem.customerOrderValidTotalSalePrice), cost = Number(orderItem.cost)

                        return {
                            ...orderItem,
                            inputOutputRatio: cost ? Math.round(customerOrderValidTotalSalePrice * 100 / cost) / 100 : 0
                        }
                    })
                    this.$nextTick(() => {
                        this.createECharts(res.Data.data)
                    })

                } else {
                    this.isLoading = false
                    this.orderDayData = []
                }
            })
        },

        // 创建订单图标
        createECharts(orderList) {
            if (!orderList || !orderList.length) {
                orderList = []
            }
            const windowWidth = document.body.clientWidth || 768
            const chartsType = this.searchData.chartsType
            let orderData = [], orderXAxisData = []
            const legendName = this.overviewDataMap[chartsType]
            orderList.map((orderItem) => {
                orderData.push(orderItem[chartsType])
                orderXAxisData.push(orderItem.createDate)
            })

            const newEcharts = echarts.init(this.$refs['overviewData-echarts'])
            if (windowWidth > 768) {
                newEcharts.setOption({
                    title: {
                        show: false
                    },
                    grid: {
                        left: '80px',
                        right: '40px',
                        top: '20px',
                        bottom: '90px'
                    },
                    legend: {
                        data: [legendName],
                        bottom: '30px',
                    },
                    tooltip: {},
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        axisLabel: {
                            show: true,
                            fontSize: '14px',
                            textStyle: {
                                color: "#999",
                            }
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: "#333"
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        data: orderXAxisData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: legendName,
                            data: orderData,
                            symbol: 'circle',
                            symbolSize: [6, 6],
                            type: 'line',
                            smooth: true,
                            lineStyle: {
                                color: '#0061E4'
                            },
                            itemStyle: {
                                normal: {
                                    color: '#0061E4'
                                }
                            },
                            areaStyle: {
                                normal: {
                                    color: {
                                        type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                                        colorStops: [
                                            {
                                                offset: 0, color: '#D1E5FD' // 0% 处的颜色
                                            },
                                            {
                                                offset: 1, color: '#fff' // 100% 处的颜色
                                            }
                                        ],
                                        global: false // 缺省为 false
                                    },
                                }
                            }
                        }
                    ]
                });
            } else {
                newEcharts.setOption({
                    title: {
                        show: false
                    },
                    grid: {
                        left: '80px',
                        right: '40px',
                        top: '20px',
                        bottom: '90px'
                    },
                    legend: {
                        data: [legendName],
                        bottom: '30px',
                    },
                    tooltip: {},
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        axisLabel: {
                            show: true,
                            fontSize: '10px',
                            textStyle: {
                                color: "#999",
                            }
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: "#333"
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        data: orderXAxisData
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            show: true,
                            fontSize: '10px',
                            textStyle: {
                                color: "#999",
                            }
                        },
                    },
                    series: [
                        {
                            name: legendName,
                            data: orderData,
                            symbol: 'circle',
                            symbolSize: [6, 6],
                            fontSize: '10px',
                            type: 'line',
                            smooth: true,
                            lineStyle: {
                                color: '#0061E4'
                            },
                            itemStyle: {
                                normal: {
                                    color: '#0061E4'
                                }
                            },
                            areaStyle: {
                                normal: {
                                    color: {
                                        type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                                        colorStops: [
                                            {
                                                offset: 0, color: '#D1E5FD' // 0% 处的颜色
                                            },
                                            {
                                                offset: 1, color: '#fff' // 100% 处的颜色
                                            }
                                        ],
                                        global: false // 缺省为 false
                                    },
                                }
                            }
                        }
                    ]
                });
            }
        },

        // 处理搜索框修改事件
        handleChangeSearchData(event) {
            const { data, item } = event, startCreateDate = this.searchData.dates[0], endCreateDate = this.searchData.dates[1]
            if (item.key === "dates") {
                const startDate = new Date(event.data.dates[0]).getTime(), endDate = new Date(event.data.dates[1]).getTime()
                if (endDate - startDate > 86400000 * 14) {
                    Message.error('日期区间不能大于14天')
                    this.$set(this.searchData, 'dates', [startCreateDate, endCreateDate])
                    return
                }
                this.searchData = data
                this.getOrderDayData()
            } else {
                this.searchData = data
                this.createECharts(this.orderDayData)
            }


        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
    .overviewData-card {
        position: relative;
        padding: 60px 60px 30px;
        margin-bottom: 20px;
        background-color: #fff;
        .overviewData-card-title {
            display: flex;
            flex-direction: row;
            align-items: center;
            position: absolute;
            left: 0;
            top: 20px;
            .overviewData-card-title-slide {
                width: 3px;
                height: 16px;
                background-color: #0061e4;
            }
            .overviewData-card-title-text {
                margin-left: 7px;
                font-size: 16px;
                font-weight: 500;
                color: #333;
            }
        }
        .overviewData-card-space {
            position: absolute;
            height: 20px;
            bottom: -20px;
            left: -20px;
            right: -20px;
            background-color: #f7f7f7;
        }
        .overviewData-card-search {
            position: absolute;
            top: 20px;
            right: -20px;
        }
        .overviewData-card-search-mobile {
            display: none;
        }
        .overviewData-echarts {
            height: 480px;
            .overviewData-echarts-content {
                width: 100% !important;
                height: 100%;
            }
        }
        .overviewData-card-content {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            .overviewData-card-content-item {
                height: 85px;
                width: 33.33%;
                margin-bottom: 80px;
                padding-left: 26px;
                border-left: 1px solid #e0dfe0;
                .overviewData-card-content-item-name {
                    font-size: 14px;
                    line-height: 14px;
                    color: #666666;
                }
                .overviewData-card-content-item-value {
                    margin: 16px 0 13px;
                    font-size: 26px;
                    line-height: 25px;
                    color: #333;
                    font-family: Bebas;
                }
                .overviewData-card-content-item-time {
                    font-size: 12px;
                    color: #999;
                }
            }
            .overviewData-card-content-item-end {
                margin-bottom: 0;
            }
        }
    }

    .overviewData-echartsBox {
        padding-bottom: 0;
        padding-left: 20px;
        padding-right: 20px;
        margin-bottom: 0;
    }
}

@media screen and (max-width: 768px) {
    .overviewData {
        padding: 1.1rem 0.3rem 0.2rem;
        .overviewData-card {
            position: relative;
            padding-top: 0.41rem;
            margin-bottom: 0.2rem;
            background-color: #fff;
            .overviewData-card-title {
                display: flex;
                flex-direction: row;
                height: 0.3rem;
                .overviewData-card-title-slide {
                    width: 0.06rem;
                    height: 0.3rem;
                    background-color: #005fed;
                }
                .overviewData-card-title-text {
                    margin-left: 0.2rem;
                    font-size: 0.3rem;
                    line-height: 0.3rem;
                    font-weight: 500;
                    font-family: Source Han Sans CN;
                    color: #333;
                }
            }
            .overviewData-card-content {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                padding-bottom: 0.53rem;
                .overviewData-card-content-item {
                    width: 50%;
                    padding-left: 0.36rem;
                    padding-top: 0.5rem;
                    padding-bottom: 0.19rem;
                    .overviewData-card-content-item-name {
                        font-size: 0.26rem;
                        line-height: 0.24rem;
                        color: #666;
                    }
                    .overviewData-card-content-item-value {
                        margin: 0.2rem 0;
                        font-size: 0.36rem;
                        line-height: 0.36rem;
                    }
                    .overviewData-card-content-item-time {
                        font-size: 0.2rem;
                        line-height: 0.2rem;
                        color: #999;
                    }
                }
            }
            .overviewData-card-search {
                display: none;
            }
            .overviewData-card-search-mobile {
                padding: 0.4rem 0.26rem 0;
                .overviewData-card-search-mobile-row {
                    margin-top: 0.3rem;
                }
            }
            .overviewData-echarts {
                overflow-x: auto;
                height: 5.5rem;
                margin-top: 0.3rem;
                position: relative;
                width: 100%;
                .overviewData-echarts-content {
                    min-width: 100%;
                    height: 100%;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/overviewData/overviewData/index.vue